// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__3ej-M","input":"Input_input__3PNbO","label":"Input_label__z-LP7","error":"Input_error__2VO4D"};